// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Scheduling mode for a `TimedAction` (see `archive/timed_action.fbs`).
 *
 * ONE_SHOT (0) — fire once at the absolute `start_at` / `stop_at` datetimes.
 * DAILY (1)    — recur every selected weekday at `start_seconds_of_day` /
 *                `stop_seconds_of_day`, interpreted in `timezone`.
 * WEEKLY (2)   — like DAILY but only on weeks where the local week index has
 *                the right parity: ((week - `anchor_week`) % `week_interval` == 0).
 *                `week_interval` 0 or 1 == every week. The anchor week is derived
 *                from `start_at`.
 * MONTHLY (3)  — recur on the days set in the `days_of_month` bitmask (bit i =>
 *                day i+1; bit 31 => the last day of the month) at the
 *                seconds-of-day, interpreted in `timezone`.
 * INTERVAL (4) — pulse the START command every `interval_seconds` within the
 *                absolute window [`start_at`, `stop_at`]; STOP fires once at
 *                `stop_at`. `start_at` is the lattice anchor.
 * MONTHLY_WEEKDAY (5) — the Nth (or last) occurrence of one weekday in the
 *                month, e.g. "1st Monday" or "last Friday", at
 *                `start_seconds_of_day`/`stop_seconds_of_day`, interpreted
 *                in `timezone`. Reuses `days_of_week` for which weekday
 *                (exactly one bit); `month_week_ordinal` (1..5) selects the
 *                Nth occurrence, overridden by `month_week_last` when true.
 *
 * ONE_SHOT MUST stay value 0 so a row written without an explicit mode (or a
 * pre-existing row reading the `FlatBuffer` default) decodes as `ONE_SHOT`.
 * Values are APPEND-ONLY — never reorder or remove an existing variant.
 */
export enum RecurrenceMode {
  ONE_SHOT = 0,
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  INTERVAL = 4,
  MONTHLY_WEEKDAY = 5,
}
